import { SVGProps } from 'react';

const PilcrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 3v11m0-5H7a3 3 0 1 1 0-6h8m-1 0v11m4 8 4-4-4-4m4 4H2"
    />
  </svg>
);
export default PilcrowRight;
